export const expoAction = (data) => async dispatch => {
   
    dispatch( {
        type: "STEP", 
        payload: data
    })
}

export default expoAction;